import { Button } from "@/components/button"
import { dollars } from "@/domains/library"
import {
  GroupVotingRewardsBy,
  VotingRewardsGroupByTabs,
} from "@/domains/old-voting-rewards/components/voting-rewards-tabs"

export const LockRewardsPageHeader = ({
  groupBy,
  numberOfLocksWithRewards,
  setGroupBy,
  totalRewardsValueUSD,
  claimAllHandler,
}: {
  groupBy: GroupVotingRewardsBy
  numberOfLocksWithRewards: number
  setGroupBy: (groupBy: GroupVotingRewardsBy) => void
  totalRewardsValueUSD: number
  claimAllHandler: () => void
}) => {
  return (
    <div className="flex items-center justify-between">
      <VotingRewardsGroupByTabs value={groupBy} onValueChange={setGroupBy} />
      <div className="flex items-center gap-2">
        <Button onClick={claimAllHandler} variant="primary" className="relative whitespace-nowrap" size="sm">
          {numberOfLocksWithRewards > 0 ? (
            <div className="text-t100 absolute -right-[6px] -top-[6px] flex h-4 w-4 items-center justify-center rounded-full border border-white bg-red-500 text-[8px]">
              {numberOfLocksWithRewards}
            </div>
          ) : null}
          Claim {dollars(totalRewardsValueUSD, 2)}
        </Button>
      </div>
    </div>
  )
}
